<template>
  <div class="admin">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['系统配置', $route.meta.title]"
    >
      <template slot="controls">
        <!-- <el-button type="danger" icon="el-icon-delete"
         :disabled="selectedList.length==0">删除</el-button> -->
        <el-button
          type="primary"
          icon="el-icon-download" @click="exportData"
          v-if="buttonVisibility.export"
          >导出数据</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleEdit('')"
          v-if="buttonVisibility.add"
          >添加</el-button
        >
        <el-button
          type="danger"
          @click="handleDel"
          v-if="buttonVisibility.delete"
        >删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <!-- <el-select v-model="searchForm.status" placeholder="是否启用" 
          style="width:100px;margin-right:5px" clearable>
          <el-option label="全部" value="99"></el-option>
          <el-option label="已启用" value="2"></el-option>
          <el-option label="未启用" value="1"></el-option>
        </el-select> -->
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="getTableData(1)"
          v-if="buttonVisibility.search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="user"
        align="center"
        show-overflow-tooltip
        label="用户名"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="真实姓名"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="tel"
        label="手机号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="organ"
        label="机构名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="role"
        label="角色名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="LogoImg"
        label="头像"
        align="center"
        show-overflow-tooltip
        v-if="showColum"
      >
      </el-table-column>
      <el-table-column
        prop="IDNumber"
        label="身份证号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="BankCardNumber"
        label="开户行"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="BankBranches"
        label="银行卡号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Unit"
        label="单位"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Division"
        label="科室"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Title"
        label="职称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="PersonnelType"
        label="注册线"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Rankname"
        label="级别"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="LevelName1"
        label="省代"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="LevelName2"
        label="市代"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="LevelName3"
        label="业务员"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="PriceLevel"
        label="区域"
        align="center"
        :formatter="formatPriceLevel"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="create"
        label="创建日期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | formatType">{{
            scope.row.status | formatStatus
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>
            <el-button
              v-if="scope.row.status == 2 && buttonVisibility.forbid"
              type="warning"
              style="padding: 2px 3px"
              plain
              @click="changeStatus(scope.row, 1)"
              >禁用</el-button
            >
            <el-button
              v-else-if="scope.row.status == 1 && buttonVisibility.enable"
              type="success"
              style="padding: 2px 3px"
              plain
              @click="changeStatus(scope.row, 2)"
              >启用
            </el-button>
            <el-button
              type="primary"
              style="padding: 2px 3px"
              plain
              @click="handleEdit(scope.row)"
              v-if="buttonVisibility.edit"
              >编辑</el-button
            >
          </div>
          <el-button
            type="warning"
            plain
            style="padding: 2px 3px"
            @click="resetPassword(scope.row)"
            v-if="buttonVisibility.resetPassword"
            >重置密码</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 添加管理员 -->
    <el-drawer
      title=""
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">编辑管理员</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="80px"
            :rules="formRule"
            ref="addForm"
          >
            <el-form-item label="用户名" prop="user">
              <el-input v-model="addForm.user" clearable></el-input>
            </el-form-item>
            <el-form-item label="真实姓名" prop="name">
              <el-input v-model="addForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item
              v-if="!addForm.userId"
              label="密码"
              prop="pass"
              class="el-form-required-true"
            >
              <el-input v-model="addForm.password" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="所属机构" prop="organId">
              <el-select
                v-model="addForm.organId"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(role, index) in organList"
                  :key="index"
                  :label="role.label"
                  :value="role.value"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="管理角色" prop="roleId">
              <el-select
                v-model="addForm.roleId"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(role, index) in roleList"
                  :key="index"
                  :label="role.label"
                  :value="role.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="部门" prop="Department">
              <el-select
                v-model="addForm.Department"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(role, index) in Department"
                  :key="index"
                  :label="role.dept_name"
                  :value="role.dept_id"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="手机号" prop="tel">
              <el-input v-model="addForm.tel" clearable></el-input>
            </el-form-item>
            <el-form-item label="注册线" prop="PersonnelType">
              <el-select
                v-model="addForm.PersonnelType"
                placeholder="请选择"
                style="width: 100%"

                clearable
              >
                <el-option
                  v-if="personnelTypeOptions.length === 0"
                  disabled
                  value=""
                  label="暂无数据"
                />
                <el-option
                  v-for="(item, index) in personnelTypeOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域" prop="PriceLevel">
              <el-select
                v-model="addForm.PriceLevel"
                @change="(val) => handlePriceLevelChange(val)"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-if="PriceLevel.length === 0"
                  disabled
                  value=""
                  label="暂无数据" 
                />
                <el-option
                  v-for="(item, index) in PriceLevel"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- v-if="addForm.userId ? (addForm.roleType == 2) : true" -->
            <el-form-item label="微信标识" prop="OpenId">
              <el-input 
                v-model="addForm.OpenId"
                clearable 
                placeholder="请输入微信标识" 
                :disabled="isOPenIdDisabled"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="LogoImg"
              label="头像"
            >
              <el-image 
                v-if="addForm.LogoImg"
                style="width: 200px; height: 200px"
                :src="$setImgUrl(addForm.LogoImg)" 
                :preview-src-list="[$setImgUrl(addForm.LogoImg)]"
                fit="cover">
              </el-image>
              <div v-else class="empty-logo">
                <i class="el-icon-picture-outline"></i>
                  <p>暂无头像</p>
              </div>
            </el-form-item>
            <el-form-item label="证照" prop="certificate_img">
              <el-image 
                v-if="addForm.certificate_img"
                style="width: 200px; height: 200px"
                :src="$setImgUrl(addForm.certificate_img)" 
                :preview-src-list="[$setImgUrl(addForm.certificate_img)]"
                fit="cover">
              </el-image>
              <div v-else class="empty-image">
                <i class="el-icon-picture-outline"></i>
                  <p>暂无证照</p>
              </div>
            </el-form-item>
            <el-form-item label="是否启用" prop="Status">
              <el-checkbox true-label="2" false-label="1" v-model="addForm.status">{{
                }}</el-checkbox>
            </el-form-item>
            <!-- <el-form-item label="性别" prop="sex">
              <el-select
                v-model="addForm.sex"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="2"></el-option>
              </el-select>
            </el-form-item> -->
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button
          type="primary"
          @click="submitForm"
        >确定</el-button>
        <el-button
          type="info"
          @click="clearForm"
        >取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//混入
import { formatStatus } from "@/mixins/filters/formatStatus.js";
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项
import { mapState } from "vuex";

export default {
  name: "admin",
  mixins: [formatStatus],
  data() {
    return {
      /**表格数据 */
      // {
      //   user:"",
      //   userId:"",
      //   organ:"",
      //   organId:"",
      //   role:"",
      //   roleId:"",
      //   roleType:"",
      //   name:"",
      //   tel:"",
      //   sex:"",
      //   address:"",
      //   create:"",
      //   status:""
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      addDrawer: false /**新增管理员drawer */,
      /**表单数据 */
      //机构id 用户名 密码 角色id 联系方式 性别 修改时该管理员id  区域  是否启用 证照  头像   注册线
      addForm: {
        user: "",
        name: "",
        password: "",
        organId: "",
        roleId: "",
        tel: "",
        sex: "",
        userId: "",
        Department: "",
        PriceLevel: "",
        status: "",
        certificate_img:"",
        LogoImg: "",
        PersonnelType:"",
        OpenId:"", //微信标识
      },
      formRule: {
        /**表单验证 */ name: [mustFill],
        user: [mustFill],
        password: [this.passFill()],
        organId: [mustFill],
        roleId: [mustFill],
        tel: [mustFill],
        sex: [mustFill],
        Department: [mustFill],
      },
      searchForm: {
        /**搜索表单 */ name: "",
        status: "99",
      },
      selectedList: [] /**select选中项 */,
      /**注册表单需要的数据-------------- */
      roleList: [] /**管理角色 */,
      organList: [] /**机构数据 */,
      Department: [] /**部门列表 */,
      PriceLevel: [] /**区域 */,
      roleType: "", //角色类型
      showColum: false, 
      personnelTypeOptions: [
          {
            label:'社团线',
            value:'社团线',
          },
          {
            label:'医院线',
            value:'医院线',
          }
        ],
    };
  },
  computed: {
    ...mapState(['buttonPermissions']),
    // 按钮权限
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['注册管理'] || [] ;
      return {
        add: buttonsLimit.includes('添加'),
        delete: buttonsLimit.includes('删除'),
        search: buttonsLimit.includes('搜索'),
        forbid: buttonsLimit.includes('禁用'),
        enable: buttonsLimit.includes('启用'),
        edit: buttonsLimit.includes('编辑'),
        resetPassword: buttonsLimit.includes('重置密码'),
        export: buttonsLimit.includes('导出数据'),
      }
    },
    isOPenIdDisabled( ) {
      // 只有编辑模式（userId有值）且 roleType 不等于 2 时才禁用
      return !!(this.addForm.userId && this.addForm.roleType != 2);
    },
  },
  created() {
    this.getPriceLevel(); //获取区域
  },
  components: {},
  mounted() {
    this.getRole(); //获取角色列表
    this.getOrgan(); //获取机构列表
    this.getTableData(); //获取管理员列表
    this.getDepartment();
    // this.handlePriceLevelChange(); //获取区域
  },
  methods: {
    updata() {
      this.getRole(); //获取角色列表
      this.getOrgan(); //获取机构列表
      this.getTableData(); //获取管理员列表
    },
    /**获取管理员数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      var data = {
        type: "GetAdminList",
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      var proc = "Proc_Admin_MembersQuery"; //存储过程名
      var type = "ReturnList";
      this.$requestSys({
        url:
          "manage/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.allPage = res.recordCount;
          this.tableData = [];
          if (res.flag == 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.tableData.push({
                user: res.data[i].username,
                userId: res.data[i].userid,
                organ: res.data[i].entname,
                organId: res.data[i].entid,
                role: res.data[i].rolename,
                roleId: res.data[i].role_id,
                roleType: res.data[i].role_type,
                name: res.data[i].name,
                tel: res.data[i].telphone,
                create: res.data[i].add_time,
                status: res.data[i].status,
                PriceLevel: res.data[i].PriceLevel,
                PersonnelType: res.data[i].PersonnelType || "",  
                IDNumber: res.data[i].IDNumber,
                BankCardNumber: res.data[i].BankCardNumber,
                BankBranches: res.data[i].BankBranches,
                Unit: res.data[i].Unit,
                Division: res.data[i].Division,
                Title: res.data[i].Title,
                LogoImg: res.data[i].LogoImg,
                Rankname: res.data[i].rankname,
                LevelName1: res.data[i].levelName1,
                LevelName2: res.data[i].levelName2,
                LevelName3: res.data[i].levelName3,
                OpenId: res.data[i].openid || "", //微信标识
              });
            }            
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    /**获取角色选项 */
    getRole() {
      this.$request({
        url: "Role/RoleList",
        method: "post",
        data: {
          Source: "99",
          status: "99",
          strWhere: "",
          pageIndex: 1,
          pageSize: 100,
        },
      })
        .then((res) => {
          if (res.Code) {
            this.roleList = [];
            for (let i = 0; i < res.Obj.length; i++) {
              this.roleList.push({
                label: res.Obj[i].RoleName,
                value: res.Obj[i].Id + "",
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取部门
    getDepartment() {
      this.$request({
        url: "Management/DepartmentAdmin/DepartmentList",
        method: "post",
        data: {
          pageIndex: 1,
          pageSize: 100,
        },
      })
        .then((res) => {
          if (res.success) {
            this.Department = res.dataList;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**获取机构选项 */
    getOrgan() {
      this.$request({
        url: "Role/EntidAdd",
        method: "post",
      })
        .then((res) => {
          if (res.Code) {
            this.organList = [];
            let entId = window.localStorage.getItem("entId");
            for (let i = 0; i < res.Obj.length; i++) {
              if (entId == "SUPERINTEND") {
                this.organList.push({
                  label: res.Obj[i].entname,
                  value: res.Obj[i].entid,
                });
              } else {
                if (entId == res.Obj[i].entid) {
                  this.organList.push({
                    label: res.Obj[i].entname,
                    value: res.Obj[i].entid,
                  });
                }
              }
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /** 区域改变触发事件 */
    handlePriceLevelChange(val) {
      this.getPriceLevel(val)
    },
    /** 获取区域 */
    getPriceLevel(selectedValue) {
      console.log('selectedValue',selectedValue);
      let data = {
        entId: window.localStorage.getItem("entId"),
        sqlValue: "",
        pageIndex: 1,
        pageSize: 15,
      };
      this.$request({
        method: "post",
        url: "GoodsAdmin/GetPriceLevel",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.PriceLevel = (res.list || []).map((item) => ({
              label: item.PriceName, // 区域编号
              value: item.PriceCode, // 区域名称
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 区域显示文字处理
    formatPriceLevel(row) {
      const priceLevel = this.PriceLevel.find(item => item.value === row.PriceLevel);
      return priceLevel ? priceLevel.label : row.PriceLevel;
    },
   
    //获取证照
    getLisence(row) {
      return new Promise((resolve, reject) => {
        let data = { type: "GetAdminCertificate", ExamUserId: row.userId };
        const params = new URLSearchParams({
          type: "ReturnList",
          json: JSON.stringify(data),
          proc: "Proc_Admin_MembersQuery"
        });
        this.$request({
          url: `admin/manage/ashx/ReturnJson.ashx?${params.toString()}`,
          method: "get",
        })
          .then((res) => {
            if (res.flag == 0 && res.data.length > 0) {
              this.addForm.certificate_img = this.$setImgUrl(res.data[0].certificate_img);
              // console.log('证照路径:', res.data[0].certificate_img);
              // console.log('处理后路径:', this.$setImgUrl(res.data[0].certificate_img));
            } else {
              this.addForm.certificate_img = "";
            }
            resolve(); // 标记完成
          })
          .catch((err) => {
            console.error('获取证照失败', err);
            this.addForm.certificate_img = "";
            reject(err);
          });
      });
    },
    // 密码参数控制
    passFill() {
      return {
        validator: (rule, value, callback) => {
          if (!this.addForm.userId) {
            if (!value) {
              return callback(new Error("该字段为必填项"));
            } else {
              return callback();
            }
          } else {
            return callback();
          }
        },
      };
    },
    // 确定重置密码吗
    resetPassword(row) {
      this.$confirm("确定重置密码吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            userId: row.userId,
            userType: "Admin",
          };
          this.$request({
            method: "post",
            url: "/Management/MemberAdmin/ResetUserPassword",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => { });
    },
    /**编辑管理员数据 */
    /**编辑管理员数据 */
    async handleEdit(row) {
      // 先清空
      this.clearForm();
      if (row) {    
        // 安全合并：只复制 row 中存在的字段到 addForm
        const allowedKeys = Object.keys(this.addForm);
        for (const key of allowedKeys) {
        if (row[key] !== undefined && row[key] !== null) {
          this.addForm[key] = row[key];
        }
        }
        // 特别处理 roleType（因为 addForm 中没有 roleType 字段）
        this.addForm.roleType = row.roleType || "";
        this.addForm.OpenId = row.OpenId || "";    
        // 确保选择区域下拉框值更新后触发事件
        this.$nextTick(() => {
          this.getPriceLevel();
        });
        // 获取证照
        await this.getLisence(row);
      } else {
        console.log('新增模式');
        this.addForm.organId = this.organList.length > 0 ? this.organList[0].value : "";
        this.addForm.roleId = this.roleList.length > 0 ? this.roleList[0].value : "";
        this.addForm.PersonnelType = this.personnelTypeOptions.length > 0 ? this.personnelTypeOptions[0]. value : "";
        this.addForm.userId = "";
        this.addForm.roleType = "";
      }
      this.addForm.sex = "1";
      this.addDrawer = true;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      // for (const key in this.addForm) {
      //   this.addForm[key] = "";
      // }
      // console.log('清空后', this.addForm);
      // this.addForm.roleType = "";
      // this.addDrawer = false;
      this.addForm = {
      user: "",
      name: "",
      password: "",
      organId: "",
      roleId: "",
      tel: "",
      sex: "",
      userId: "",
      Department: "",
      PriceLevel: "",
      status: "",
      certificate_img: "",
      LogoImg: "",
      PersonnelType: "",
      OpenId: "",
      };
      this.addForm.roleType = "";
      this.addDrawer = false;
    },
    /**修改账户状态 */
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 0) {
        msg = "确定删除吗?";
        type = "error";
      } else if (status == 1) {
        msg = "确定禁用吗?";
        type = "warning";
      } else if (status == 2) {
        msg = "确定启用吗?";
        type = "success";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            type: "PC_SetUserInfo",
            strWhere: "'" + row.userId + "'",
            uptype: status,
          };
          let proc = "Proc_Admin_MembersQuery"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "manage/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              //提示成功，刷新数据
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let url = "";
          let data = {};
          if (this.addForm.userId) {
            url = "Management/ManagerAdmin/EditManager";
            data = {
              UserName: this.addForm.user,
              PassWord: this.addForm.password || "",
              EntId: this.addForm.organId,
              RoleId: this.addForm.roleId,
              Name: this.addForm.name,
              Telephone: this.addForm.tel,
              // sex: this.addForm.sex,
              UserId: this.addForm.userId,
              Department: this.addForm.Department,
              PriceLevel: this.addForm.PriceLevel,
              Status: this.addForm.status,
              CertificateImg: this.addForm.certificate_img,
              LogoImg: this.addForm.LogoImg,
              PersonnelType: this.addForm.PersonnelType,
              OpenId: this.addForm.OpenId || "",
            };
          } else {
            url = "/Management/ManagerAdmin/AddManager";
            data = {
              UserName: this.addForm.user,
              PassWord: this.addForm.password || "",
              EntId: this.addForm.organId,
              RoleId: this.addForm.roleId,
              Name: this.addForm.name,
              Telephone: this.addForm.tel,
              // sex: this.addForm.sex,
              UserId: this.addForm.userId,
              Department: this.addForm.Department,
              PriceLevel: this.addForm.PriceLevel,
              Status: this.addForm.status,
              CertificateImg: this.addForm.certificate_img,
              LogoImg: this.addForm.LogoImg,
              OpenId: this.addForm.OpenId || "",
            };
          }
          this.$request({
            url: url,
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.clearForm();
                this.getTableData();
              } else {
                //失败提示
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    /**删除角色 */
    handleDel() {
      if (this.selectedList.length == 1) {
        this.$confirm("确定删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error",
        })
          .then(() => {
            let row = this.selectedList[0];
            this.changeStatus(row, 0);
          })
          .catch(() => {});
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
   
    exportData() {
      const auth = window.localStorage.getItem("auth");
      const data = {
        type: "GetAdminList",
        strWhere: this.searchForm.name || "",
        PageIndex: 1,
        PageSize: 20,
        // PageSize: 1048576,
      };
      this.$request({
        url: 'Management/ManagerAdmin/Exprot',
        method: 'get',
        headers:{
          Auth: auth,
        },
        params: {
          type: "ReturnList",
          json: encodeURIComponent(JSON.stringify(data)),
          proc: "Proc_Admin_MembersQuery",
          name: "注册人员"
        },
        responseType: 'blob',
      })
        .then((res) => {
          // const contentType = res.headers['content-type'] || 'application/vnd.ms-excel';

          // const blob = new Blob([res.Blob], { type:" application/vnd.ms-excel" });
          // const blob = new Blob([res.Blob], { type:" application/vnd.ms-excel" });

          const downloadUrl = window.URL.createObjectURL(res);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = '注册人员.xls';
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(downloadUrl);
          document.body.removeChild(link);
        })
        .catch((err) => {
          console.log('err',err);
          
        });
    }
  }
};
</script>

<style scoped>
.admin {
  width: 100%;
  height: 100%;
}
.empty-image {
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dcdfe6;
  color: #909399;
}
.empty-logo {
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dcdfe6;
  color: #909399;
  /* border-radius: 50%; */
}
</style>
